import React from "react";
import GameObjects from "../../GameObjects";

class Labs extends React.Component {

    FinishMove = () => {
        if (this.props.FinishMove) {
            this.props.FinishMove();
        }
    }

    render() {
        return <div className={`position-${this.props.absolute === true ? "absolute" : "fixed"} w-100 h-100`} style={{
            backgroundImage: `url(${process.env.PUBLIC_URL + "/assets/images/Labs/bg.png"})`,
            backgroundPositionX: 'center',
            backgroundPositionY: 'bottom',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            top: '0'
        }}>
            <div className="position-absolute user-select-none" style={{
                right: '1%',
                bottom: '5%'
            }}><GameObjects objectCss="ChildInLabs" status={this.props.currentStatus} FinishMove={this.FinishMove} /></div>

        </div>
    }
}
export default Labs;